export * from './authorization.service';
import { AuthorizationService } from './authorization.service';
export * from './authorization.serviceInterface';
export * from './authorizationPassword.service';
import { AuthorizationPasswordService } from './authorizationPassword.service';
export * from './authorizationPassword.serviceInterface';
export * from './images.service';
import { ImagesService } from './images.service';
export * from './part.service';
import { PartService } from './part.service';
export * from './role.service';
import { RoleService } from './role.service';
export * from './role.serviceInterface';
export * from './transactionData.service';
import { TransactionDataService } from './transactionData.service';
export * from './transactionList.service';
import { TransactionListService } from './transactionList.service';
export * from './user.service';
import { UserService } from './user.service';
export * from './user.serviceInterface';
export * from './warehouse.service';
import { WarehouseService } from './warehouse.service';
export const APIS = [AuthorizationService, AuthorizationPasswordService, ImagesService, PartService, RoleService, TransactionDataService, TransactionListService, UserService, WarehouseService];
